/**
* Constructor voor RegularSearch
*
* @param endPoint URL van Elastic Search
* @param paramsCallback Callback voor het ophalen van formwaarden
* @param containerSelector Selector van container met resultaten
* @param hitProcessor Processor voor het omzetten van Elastic Search hit naar object
* @param hitTemplate Template voor een resultaat
*/
RegularSearch = function (
    endPoint,
    containerSelector,
    hitProcessor,
    hitTemplate

) {
    this.endPoint = endPoint;
    this.containerSelector = containerSelector;
    this.hitProcessor = hitProcessor;
    this.hitTemplate = hitTemplate;
}

RegularSearch.prototype = {
    endPoint : null,
    paramsCallback : null,
    containerSelector : null,
    paginationSelector : null,
    numHitsSelector : null,
    hitProcessor: null,
    hitTemplate : null,
    params : null,
    requestParams : null,
    noResultsHtml: null,
    callbackResultsLoaded: null,

    /**
    * Uitvoeren van zoekopdracht
    *
    * 1. Haalt de parameters uit het formulier op aan de hand van een callback
    * 2. Haalt de parameters op voor de zoekopdracht van Elastic Search
    * 3. Maakt het request naar Elastic Search en verwerkt de response
    */
    search: function() {
        this.clearContainer();
        this.showLoading();
        if (this.paramsCallback)
            this.params = this.paramsCallback();

        if (this.additionalParams)
            this.params = $.extend(this.params, this.additionalParams);

        if (this.fixedParams)
            this.params = $.extend(this.params, this.fixedParams);

        this.requestParams = {
            'type' : 'get',
            'data' : {params: this.params},
            'dataType': "json",
            'contentType' : 'application/json',
        };

        $.ajax(this.endPoint, this.requestParams)
            .done(this.processResult.bind(this));

    },

    /**
    * Verwerken van resultaat afkomstig van Elastic Search
    *
    * @param result
    */
    processResult: function(result) {
        this.clearContainer();
        var that = this;

        var numHits = result.hits.total;

        // Tonen van totaal aantal hits
        if (this.numHitsSelector)
            $(this.numHitsSelector).html(numHits);


        // Tonen van paginering
        var currentPage = this.params.page;

        var numPages = Math.ceil(numHits / this.params.numResultsPerPage);

        if (this.paginationSelector) {

            var pagination = '';

            if (numPages > 1) {

                if (currentPage > 1)
                    pagination+= '<li class="previous" data-hook="page" data-page="' + (currentPage - 1) + '"></li>';

                var prePadding = false;
                var postPadding = false;

                for (var page=1; page<=numPages; page++) {

                    if (
                        page != 1 &&
                        page != numPages
                    ) {
                        if (page < currentPage - 1) {
                            if (prePadding)
                                continue;

                            prePadding = true;
                            pagination+= '<li data-page="' + page + '">..</li>';
                            continue;
                        }

                        if (page > currentPage + 1) {
                            if (postPadding)
                                continue;
                            postPadding = true;
                            pagination+= '<li data-page="' + page + '">..</li>';
                            continue;
                        }
                    }

                    var active = page == currentPage ? ' class="active"' : '';
                    pagination+= ' \
                        <li' + active + ' data-hook="page" data-page="' + page + '"> \
                            '+page+' \
                        </li>';
                }

                if (currentPage < numPages)
                    pagination+= '<li class="next" data-hook="page" data-page="' + (currentPage + 1) + '"></li>';
            }

            $(this.paginationSelector).html(pagination);
        }

        if (numHits == 0 && this.noResultsHtml)
            $(this.containerSelector).html(this.noResultsHtml);


        // Doorlopen van de resultaten
        $(result.hits.hits).each(function(i,hit) {
            // Ophalen van object voor gebruik in template
            var templateObject = that.hitProcessor(hit);
            // Ophalen van de DOM aan de hand van object
            var dom = that.hitTemplate(templateObject);
            // Toevoegen van DOM aan de container met resultaten
            $(dom).appendTo(that.containerSelector);
        });

        if(this.callbackResultsLoaded)
            this.callbackResultsLoaded();
    },

    /**
    * Loading icon tonen
    */
    showLoading: function() {
        $(this.containerSelector).append('<div class="loading-spinner"></div>');
    },

    /**
    * Leegmaken van de resultaten
    */
    clearContainer: function() {
        $(this.containerSelector).empty();
    },

    /**
    * Instellen van list element voor paginering
    * @param string
    */
    setPaginationSelector: function(paginationSelector) {
        this.paginationSelector = paginationSelector;
    },

    /**
    * Instellen van element waarin totaal aantal resultaten wordt getoond.
    *
    * Na het ophalen van de zoekresultaten wordt de HTML van dit element
    * veranderd naar het aantal resultaten.
    *
    * @param string
    */
    setNumHitsSelector: function(numHitsSelector) {
        this.numHitsSelector = numHitsSelector;
    },

    /**
    * Instellen van extra parameters die worden meegegeven aan de backend
    *
    * Deze parameters worden samengevoegd met het resultaat van  this.getParams
    * @param {Object}
    */
    setAdditionalParams: function(params) {
        this.additionalParams = params;
    },

    /**
    * Instellen van extra parameters die worden meegegeven aan de backend die niet gewijzigd kunnen worden
    *
    * Deze parameters worden samengevoegd met het resultaat van  this.getParams
    * @param {Object}
    */
    setFixedParams: function(params) {
        this.fixedParams = params;
    },

    /**
    * Instellen van callback voor het ophalen van zoekparameters.
    *
    * @param paramsCallback
    */
    setParamsCallback: function(paramsCallback) {
        this.paramsCallback = paramsCallback;
    },

    /**
    * Zetten van html die wordt getoond op het moment
    * dat er geen resultaten zijn
    *
    * @param noResultsHtml
    */
    setNoResultsHtml: function(noResultsHtml) {
        this.noResultsHtml = noResultsHtml;
    },

    setCallbackResultsLoaded: function(callbackResultsLoaded) {
        this.callbackResultsLoaded = callbackResultsLoaded
    }
}